export default __webpack_public_path__ + "static/media/swipe.90fe584b.svg";